import ProductCard from "./ProductCard";

const products = [
  {
    id: 2001,
    name: "1000ml Matte Black Stainless Steel Vacuum Insulated Water Bottle With Carrying Strap Durable And Stylish",
    price: 1890,
    image: "/image/kids/Matte Black Stainless Steel Vacuum Insulated Water Bottle With Carrying Strap.png",
  },
  {
    id: 2002,
    name: "Double-Sided Prank Water Gun Toy – Funny Summer Squirt Pistol Water Toy for Kids, Outdoor Pool & Beach Parties",
    price: 396 ,
    image: "/image/kids/Double-Sided Prank Water Gun Toy.jpg",
  },
  {
    id: 2003,
    name: "Premium 6-in-1 Electric Baby Nail Trimmer Set – Safe Infant Nail Filer, Clipper Alternative Kit with Storage Case - Random Color",
    price: 800,
    image: "/image/kids/Premium 6-in-1 Electric Baby Nail Trimmer Set.jpg",
  },
  {
    id: 2004,
    name: "Premium Refrigerator Children's Lock – Self-Adhesive Baby Safety Freezer Door Lock with One-Hand Operation",
    price: 315,
    image: "/image/kids/Premium Refrigerator Children's Lock.png",
  },
  {
    id: 2005,
    name: "Food Pacifier + Feeder Spoon / Fresh Fruit Food Baby , Feeding Safe Fruit Feeder - Random Color",
    price: 305,
    image: "/image/kids/Food Pacifier + Feeder Spoon.jpg",
  },
  // Add other products...
];

export default function ProductGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          id={product.id}
          image={product.image}
          name={product.name}
          price={product.price}
          description={product.description}
        />
      ))}
    </div>
  );
}